module.exports = __webpack_public_path__ + "9fd0f3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/slide5.png
// module id = 686
// module chunks = 1